import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from './router';
import { EmailStatus, EmailStatusResult, LoginResult } from './EmailStatus';

Vue.use(Vuex);
const emailLocalStorage = localStorage.getItem('email') || '';

export default new Vuex.Store({
  state: {
    email: emailLocalStorage,
    status: 'not-tested',
    userCreated: false,
    showPasswordError: false,
    failedAttempts: 0,
    maxAttempts: 0,
  },
  mutations: {
    EMAIL_SUBMIT(state, payload) {
      state.email = payload.email;
    },
    EMAIL_CLEAR_ERROR(state) {
      state.status = 'not-tested';
    },
    INCORRECT_LOGIN(state, payload) {
      state.showPasswordError = true;
      state.failedAttempts = payload.failedAttempts;
      state.maxAttempts = payload.maxAttempts;
    },
    CLEAR_LOGIN_ERROR(state) {
      state.showPasswordError = false;
    },
    START_LOGIN(state, payload) {
      state.email = payload.email;
    },
    EMAIL_SUCCESS(state, emailValid: EmailStatusResult) {
      state.status = emailValid.status;
    },
    USER_CREATED(state, userCreated: { successful: boolean }) {
      state.userCreated = userCreated.successful;
    },
  },
  actions: {
    emailSubmit({commit}, payload: { email: string }) {
      commit('EMAIL_SUBMIT', payload);
      axios
        .get(
          process.env.VUE_APP_ROOT_API +
          '/api/email/HasEmail?email=' +
          encodeURIComponent(payload.email),
        )
        .then((r: any) => r.data)
        .then((emailValid: { status: EmailStatus }) => {
          commit('EMAIL_SUCCESS', emailValid);
          localStorage.setItem('email', payload.email);
          if (emailValid.status === 'maverick-user') {
            router.push('create-account');
          }
          if (emailValid.status === 'no-match') {
            router.push('leads');
          }
        })
        .catch(() => {
          router.push('error');
        });
    },
    loginSubmit({commit}, payload: { email: string; password: string; returnUrl: string }) {
      commit('START_LOGIN', payload);
      axios
        .post(process.env.VUE_APP_ROOT_API + '/api/login', payload)
        .then((r: any) => r.data)
        .then((result: LoginResult) => {
          handleLoginResult(result, payload, commit);
        })
        .catch(() => {
          router.push('error');
        });
    },
    createAccount({commit}, payload: { email: string; password: string }) {
      axios
        .post(process.env.VUE_APP_ROOT_API + '/api/CreateUser', payload)
        .then(() => {
          router.push('created-account');
        })
        .catch(() => {
          router.push('error');
        });
    },
    forgotPassword({commit}, payload: { email: string }) {
      axios
        .post(
          process.env.VUE_APP_ROOT_API + '/api/Password/ForgotPassword',
          payload,
        )
        .then((r: any) => r.data)
        .then((user: { successful: boolean }) => {
          router.push('forgot-password-sent');
        })
        .catch(() => {
          router.push('error');
        });
    },
    changePassword({commit}, payload: { oldPassword: string; newPassword: string }) {
      axios
        .post(
          process.env.VUE_APP_ROOT_API + '/api/Password/ChangePassword',
          payload
        )
        .then((response) => {
          const data = response.data;
          const result = data && (data.Result !== undefined ? data.Result : data.result);

          if (result === true) {
            router.push({ name: 'change-password-success' });
            return;
          }

          const failureReason = data && (data.FailureReason !== undefined ? data.FailureReason : data.failureReason);

          if (!failureReason) {
            router.push('error');
            return;
          }

          const encoded = btoa(failureReason);
          router.push({
            name: 'change-password-error',
            query: { p: encoded }
          });
        })
        .catch(() => {
          router.push('error');
        });
    },
    resetPassword({commit}, payload: { id: string; code: string; password: string }) {
      axios
        .post(
          process.env.VUE_APP_ROOT_API + '/api/Password/ResetPassword',
          payload,
        )
        .then(r => r.data)
        .then((user: { successful: boolean }) => {
          router.push('/');
          window.location.reload();
        })
        .catch(() => {
          router.push('error');
        });
    },
    sendActivationLink({state}) {
      axios
        .post(process.env.VUE_APP_ROOT_API + '/api/Email/ActivationLink', {
          email: state.email,
        })
        .then(r => r.data)
        .then((user: { successful: boolean }) => {
          router.push('/activation-mail-sent');
        })
        .catch(() => {
          router.push('error');
        });
    },
  },
});

function handleLoginResult(result: LoginResult, payload: { returnUrl: string }, commit: any) {
  if (result.isSuccessfull) {
    window.location.href = 'api/redirect?returnUrl=' + payload.returnUrl || '';
  } else {
    switch (result.type) {
      case 'email-verification-required': {
        router.push('/account-not-activated');
        break;
      }
      case 'is-not-allowed': {
        router.push('/not-allowed');
        break;
      }
      case 'is-locked-out': {
        if (result.lockoutEnd) {
          router.push({
            name: 'locked-out',
            query: { p: result.lockoutEnd }
          });
        } else {
          router.push('/locked-out');
        }
        break;
      }
      case 'password-expired': {
        router.push('/change-password');
        break;
      }
      case 'incorrect-login':
      case 'general': {
        commit('INCORRECT_LOGIN',
          {
            failedAttempts: result.failedAttempts,
            maxAttempts: result.maxAttempts,
          });
      }
    }
  }
}

